import { Component, ContentChildren, Input, OnInit, QueryList } from '@angular/core';
import { File } from '@app/core/interfaces/download/file';
import { ResourceType } from '@app/core/interfaces/portal/resource-type';
import { TranscludeDirective } from '@app/shared/directives/transclude.directive';

@Component({
  selector: 'portal-file',
  templateUrl: './file.component.html',
  standalone: false,
})
export class FileComponent implements OnInit {
  @Input()
  file: File;

  @Input()
  buttonClass: string = 'btn btn-primary';

  @ContentChildren(TranscludeDirective)
  transclusions: QueryList<TranscludeDirective>;

  className!: string;

  protected readonly ResourceType = ResourceType;

  ngOnInit(): void {}
}
